import * as Vest from 'vest';
import { DateTime as LuxonDateTime} from 'luxon';

function validateTime(hhmm:string): boolean {

    if (LuxonDateTime.fromFormat(hhmm, "HH:mm").isValid
    || LuxonDateTime.fromFormat(hhmm, "HH").isValid
    || LuxonDateTime.fromFormat(hhmm, "H").isValid 
    || LuxonDateTime.fromFormat(hhmm,"H:mm").isValid)
    {
        return true;
    }
    else
    {
        return false;
    }
    
  }

  function convertToMinutes(paramin:string):number{
    //on a passé la validation avec validateTime
    var totMinutes=0;
    var H=0;
    var mm=0;
    var hhmm=paramin;

    switch(hhmm.length) { 
        case (1): { 
           //H 
           totMinutes= parseInt(hhmm) * 60;
     
           break; 
        } 
        case (2): { 
            //HH
           
            if(hhmm.startsWith("0"))
            {
                hhmm=hhmm.substring(0,2);
            }
            totMinutes= parseInt(hhmm) * 60;
 
            break; 
         } 
        case 4: { 
            //H:mm; 
            H=parseInt(hhmm.substring(0,1));
            mm=parseInt(hhmm.substring(2,4));

            totMinutes= ((H*60)+mm);
            break; 
         } 
         case 5: { 
            //HH:mm
            H=parseInt(hhmm.substring(0,2));
            mm=parseInt(hhmm.substring(3,5));

            totMinutes= ((H*60)+mm);
            break; 
         } 
        default: { 
           //statements; 
           totMinutes=0;
           break; 
        } 
     } 
      

     return totMinutes;

  }

export const FormSuite = Vest.create((data = {}) => {
  
    if(!data.partTimeValue)
    {
        return true;
    }else{  
      

    // Si on change l'horaire pour un jour de la semaine: on vérifie le format puis on vérifie si l'horaire ne dépasse pas l'horaire de référence pour le jour concerné.
    //------------------------------------------------------------------ Monday
    Vest.test('MondaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.MondaySchedule);
    })  //---------------------------------------------------------------------------------------------
    Vest.test('TuesdaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.TuesdaySchedule);
    })
    Vest.test('WednesdaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.WednesdaySchedule);
    })
    Vest.test('ThursdaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.ThursdaySchedule);
    })
    Vest.test('FridaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.FridaySchedule);
    })
    Vest.test('SaturdaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.SaturdaySchedule);
    })
    Vest.test('SundaySchedule','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.SundaySchedule);
    })

 


    
     // Si on change l'horaire DE REFERENCE pour un jour de la semaine: on vérifie le format puis on vérifie si l'horaire ne dépasse pas l'horaire de référence pour le jour concerné.
    //------------------------------------------------------------------ Monday REF
    Vest.test('MondayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.MondayScheduleRef);
    })
    Vest.test('TuesdayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.TuesdayScheduleRef);
    })
    Vest.test('WednesdayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.WednesdayScheduleRef);
    })
    Vest.test('ThursdayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.ThursdayScheduleRef);
    })
    Vest.test('FridayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.FridayScheduleRef);
    })
    Vest.test('SaturdayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.SaturdayScheduleRef);
    })
    Vest.test('SundayScheduleRef','ERROR_FORMAT_HH:MM', () => {
        return validateTime(data.SundayScheduleRef);
    })
}

});